import React, { useState ,useEffect} from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import "react-datepicker/dist/react-datepicker.css";   
import CommonAPI from '../../Common/CommonAPI';
import moment from 'moment';
import FadeLoader from "react-spinners/HashLoader"; 

function ScheduledTransfer (props) {  
    var PaymentsRefNumber = JSON.parse(sessionStorage.getItem("PaymentsHis")).RefNumber;
    
    const [Benename,setBenename] = useState("");
    const [SavAccountNum,setSavAccountNum] = useState("");
    const [MainCustomerName,setMainCustomerName] = useState("");
    const [BeneBankAccountNum,setBeneBankAccountNum] = useState("");
    const [Amount,setAmount] = useState("");
    const [BeneBank,setBeneBank] = useState("");
    const [BeneBranch,setBeneBranch] = useState("");
    const [StartDate,setStartDate] = useState("");
    const [BeneReference,setBeneReference] = useState("");
    const [YourReference,setYourReference] = useState("");
    const [PayLocation,setPayLocation] = useState("");
    const [ReferenceNumber,setReferenceNumber] = useState("");
    const [Status,setStatus] = useState("");
    const [DetailList,setDetailList] = useState([]);
    const [CancelPayment,setCancelPayment] = useState(false);
    const [EnteredPassword,setEnteredPassword] = useState("");
    const [SuccessLoading,setSuccessLoading] = useState(true);

    useEffect( () => {
        GetTransferDetailsAPI();        
      },[]);

      const ResponseLoadingModal = () => {
        return(
            <Modal
            size="lg"
            centered 
            className="loading1" show={SuccessLoading}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={SuccessLoading}
                />       
           </Modal>
         )
      }

    const GetTransferDetailsAPI = () =>{
        CommonAPI.GetTransferDetails({PaymentsRefNumber: PaymentsRefNumber},(results) =>{   
            if(results){                    
                setBenename(results.beneName);
                setSavAccountNum(results.savingsAccount?results.savingsAccount.accountNo:null);
                setMainCustomerName(results.savingsAccount?(results.savingsAccount.mainCustomer.title+results.savingsAccount.mainCustomer.firstName+" "+results.savingsAccount.mainCustomer.lastName):null);
                setBeneBankAccountNum( results.transferAccount);
                setAmount(results.amount);
                setBeneBank(results.bankBranch?results.bankBranch.bank.name:null);
                setBeneBranch(results.bankBranch?results.bankBranch.name:null);
                setStartDate(results.dueDate);
                setBeneReference(results.reference);
                setYourReference(results.beneReference);
                setPayLocation(results.branch);
                setReferenceNumber(results.retRefNumber);
                setDetailList(results.accTransSummery);
                setStatus(results.status);
                setSuccessLoading(false);
            } 
            if(results.message){
                console.log("Invalid Request!");
                setSuccessLoading(false);
            }          
        });
      }   
      if(SuccessLoading){
        return (ResponseLoadingModal());
      }else{
        return (
            <Modal
              show={props.isOpen}
              size="xl"
              aria-labelledby="contained-modal-title-vcenter"
              centered 
              backdrop="static"
              onHide={props.toggle}
            >
              <Modal.Header closeButton>
                <Modal.Title className='hselect' id="contained-modal-title-vcenter">
                  <p className='modal-head-f'>TRANSFERS</p><br/>HISTORY DETAILS
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
               
                <Row  className='div-background d-flex align-items-start'>                    
                    <Col lg={2} className="res-margin">
                      <div >
                        <p className='p-box5'>{Status==="ACT"?"Active":Status==="PRO"?"Processed":Status==="FLR"?"Fail and Return":Status==="INI"?"Initiate":"-"}</p>
                        <p className='p-line'>{SavAccountNum}</p>
                        <p className='p-line'>{MainCustomerName}</p>
                      </div>
                   </Col>
                    <Col lg={2} className="res-margin">
                        <div>
                            <p className='p-line2'>PAYMENT ON</p>
                            <p className='p-box2'> {moment(StartDate).format('DD/MM/YYYY')} </p>
                            <p className='p-line2 m-top'>REF.NUMBER</p>
                            <p className='p-line'>{ReferenceNumber}</p>
                        </div>
                   </Col>
                    <Col lg={3} className="res-margin">
                        <div>
                            <p className='p-line2'>BENEFICIARY DETAILS</p>
                            <p className='p-line m-top'> {Benename}</p>
                            <p className='p-line '>ACCOUNT -{BeneBankAccountNum}</p>
                            <p className='p-line'>{BeneBank} - {BeneBranch}</p>                            
                        </div>
                   </Col>
                    <Col lg={3} className="res-margin">
                        <div>
                        <div >
                            <p className='p-line2'>BENEFICIARY REFERENCE</p>
                            <p className='p-line '>{BeneReference?BeneReference:"-"} </p>
                            <p className='p-line2 m-top'>YOUR REFERENCE</p>
                            <p className='p-line2'>{YourReference}</p>
                            <p className='p-line m-top'>LOCATION - {PayLocation}</p>                            
                        </div>
                        </div>
                   </Col>
                    <Col lg={2}>
                        <div>                            
                            <p className='p-line2'>LKR {parseFloat(Amount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>  
                        </div>
                       
                   </Col>
                </Row>
               { DetailList.length>0?
                <Table className='block-top' hover responsive>
                  <thead >
                    <tr>
                      <th className='td-width3'>Account Number</th>
                      <th className='td-width3'>Transaction Details</th>
                      <th className='td-width3'>Amount Rs.</th>
                    </tr>
                  </thead>
                  <tbody>
                    {DetailList.length ? DetailList.map((listValue, index) => {
                      return (
                        <tr  >
                          <td className='td-width3'>
                            <p className='tb-text m-top'>{listValue.accountNo}</p>
                          </td>
                          <td className='td-width3'>
                            <p className='tb-text m-top'>{listValue.transactionCode}</p>
                          </td>
                          <td className='td-width3'>
                            <p className='tb-text m-top'>{parseFloat(listValue.amount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                          </td>
                        </tr>
                      )
                    }) :
                      <Row className='tablebody'>
                        <p className='h-text block-top'>No Records</p>
                      </Row>
                    }
                  </tbody>
                </Table>
                : null
                }
                
                              
              </Modal.Body>              
            </Modal>
          );
        }
    }

export default ScheduledTransfer;